module.exports = [{"type":"title","text":"2025-01-21"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual U-margined: Added descriptions for the Price and PriceRate fields in the query all orders API."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-01-21.json
// module id = /m37
// module chunks = 3